module.exports = __webpack_public_path__ + "static/img/SCN_DES.e7687dc1.png";